var _defs, _path, _path2, _path3, _g, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnStep6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "on",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.972,
    height: 61,
    viewBox: "0 0 49.972 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3735a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a3da"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M17.2,52.3H13.5a2.862,2.862,0,0,1-2.8-2.8V44.7a4.7,4.7,0,0,0,3.7-4.6V38.2a1.9,1.9,0,0,0-1.9-1.9V31.6a.9.9,0,1,0-1.8,0v4.7H8.8V31.6a.9.9,0,0,0-.9-.9c-.5,0-.9.6-.9,1.1v4.7a1.9,1.9,0,0,0-1.9,1.9v1.9a4.7,4.7,0,0,0,3.7,4.6v4.8a4.674,4.674,0,0,0,4.6,4.7h3.8a.6.6,0,0,0,.1.4C17.3,54.6,17.2,52.3,17.2,52.3Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    d: "M23.5,0H37.1a6.018,6.018,0,0,1,6,6V55a6.018,6.018,0,0,1-6,6H23.5a6.018,6.018,0,0,1-6-6h0V6A6.018,6.018,0,0,1,23.5,0Z",
    fill: "#e1f4fb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M22.5,3.7H38.2a2.006,2.006,0,0,1,2,2V55.4a2.006,2.006,0,0,1-2,2H22.5a2.006,2.006,0,0,1-2-2V5.7A2.006,2.006,0,0,1,22.5,3.7Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flash",
    transform: "translate(0 45.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.1,4.4c0-.1-.1-.1-.2-.1H3.8l.5-4c0-.2-.1-.3-.2-.3s-.2,0-.2.1L0,6.8v.3c0,.1.1.1.2.1H3.3l-.4,4.1c0,.1.1.2.2.3.1,0,.2,0,.2-.1L7.1,4.8c.1-.2.1-.3,0-.4Z",
    fill: "#fff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M25.593,26.973H2.767a4.031,4.031,0,1,1,0-8.062h8.789a1.106,1.106,0,0,0,0-2.211H2.44a3.7,3.7,0,1,1,0-7.4h8.731a1.493,1.493,0,0,0,0-2.985H2.517a3.78,3.78,0,1,1,0-7.559H25.593v2.5H2.517a1.28,1.28,0,0,0,0,2.559h8.654a3.993,3.993,0,1,1,0,7.985H2.44a1.2,1.2,0,1,0,0,2.4h9.116a3.606,3.606,0,1,1,0,7.212H2.767a1.531,1.531,0,0,0,0,3.062H25.593Z",
    transform: "translate(24.379 8.819)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnStep6);
export default __webpack_public_path__ + "static/media/on-step6.5c24734541d1e45df8afb86267cbf50c.svg";
export { ForwardRef as ReactComponent };